import { render, staticRenderFns } from "./listFiltersV2.vue?vue&type=template&id=3c2f9480&scoped=true"
import script from "./listFiltersV2.vue?vue&type=script&lang=js"
export * from "./listFiltersV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f9480",
  null
  
)

export default component.exports